import React from 'react';

const About = () => {
    return (
        <div className='container mx-auto min-h-screen max-w-5xl px-5 text-xl md:text-2xl mb-20 text-center'>
            <p>Hi there!</p>
            <h1 className='text-2xl md:text-4xl font-bold my-11'>I’m a Md moniruzzaman</h1>
            <p className='my-5'>I've always loved technology. From a young age, technology has interested me. Most children play video games of some kind, from tetris to spyro, crash bandicoot to final fantasy, I loved playing with computers, but my interest didn't stop just at entertainment.

                The more I played, the more I wanted to understand how things worked. If something broke, I would take it apart and figure out what had gone wrong, trying to get it back to normal.

                I remember taking apart my computer when I was 12, an event which horrified my parents.

                I still build my own computers.

                I never lost my curiosity, but my interest in technologies changed as I expanded my knowledge from taking apart equipment to building new websites in code.

                Now I focus on people and learning how they interact with websites, making sure they can achieve their goals leaving them satisfied and more likely to return as customers.</p>
            <p className='my-5'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Et a commodi laboriosam itaque omnis numquam. Doloribus nulla eligendi, veniam error quae nobis iste nesciunt repellat deleniti quidem fugit, minima sed.</p>
            <p className='my-5'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Et a commodi laboriosam itaque omnis numquam. Doloribus nulla eligendi, veniam error quae nobis iste nesciunt repellat deleniti quidem fugit, minima sed.</p>


        </div>
    );
};

export default About;